export type TypeDuration = 'FIXED' | 'PT1H' | 'PT24H' | 'PT48H' | 'P7D' | 'P30D' | 'P3M';

export const TIME_RANGES: {
  text: string;
  value: TypeDuration;
  selectable: boolean;
}[] = [
  {
    text: 'Fixed',
    value: 'FIXED',
    selectable: false,
  },
  {
    text: 'Last 24 Hours',
    value: 'PT24H',
    selectable: true,
  },
  {
    text: 'Last 48 Hours',
    value: 'PT48H',
    selectable: true,
  },
  {
    text: 'Last 7 Days',
    value: 'P7D',
    selectable: true,
  },
  {
    text: 'Last 30 Days',
    value: 'P30D',
    selectable: true,
  },
  {
    text: 'Last 3 Months',
    value: 'P3M',
    selectable: true,
  },
];

export const TIME_RANGE_MIN: TypeDuration = 'PT1H';
export const TIME_RANGE_MAX: TypeDuration = 'P3M';

export const TIME_RANGE_DEFAULT: TypeDuration = 'PT24H';
